export default __webpack_public_path__ + "static/media/EditDark.2c607f0f.svg";